import type { OutreachCandidate } from '../../types/taOutreach';

/** The person's LinkedIn Recruiter profile — the link "Who was checked" uses. */
export const recruiterProfileUrl = (recruiterId: string) => `https://www.linkedin.com/talent/profile/${encodeURIComponent(recruiterId)}`;

/** Where a candidate's name links to: Recruiter profile, else the public profile, else nowhere. */
export function profileLinkOf(c: Pick<OutreachCandidate, 'recruiterId' | 'publicUrl'>): string | null {
  if (c.recruiterId) return recruiterProfileUrl(c.recruiterId);
  return c.publicUrl && /^https:\/\/([a-z]+\.)?linkedin\.com\//i.test(c.publicUrl) ? c.publicUrl : null;
}
